import React, { ChangeEvent, Component } from "react";
import { AssetCard } from "@10x/dubai-rest-api/dist/property_registry/entity";
import { downloadCertificate, getUnitNumber, getVillaName, TabuPropertyType } from "@my-dld/utils/PropertyUtils";
import { CurrencyUtil, I8N, LocaleUtil, StringUtil } from "@eres/core";
import { DataTableLang } from "@my-dld/utils/DataTableUtils";
import Strings from "@my-dld/assets/strings";
import { ImperialSystem, UnitSystem } from "@my-dld/utils/UnitUtils";
import { navigate } from "@my-dld/utils/StoreUtils";
import ListDataView from "../DataView/ListDataView";
import { isEmptyStringOrNull } from "@eres/core/dist/StringUtils";

export interface OPProps {
	properties?: AssetCard[];
	type: TabuPropertyType;
	unit: UnitSystem;
	isSelectable?: boolean;
	masterProperty?: AssetCard;
	sProperties?: AssetCard[];
	onSelect?: ( p: AssetCard, checked: boolean ) => void;
}

class PropertyTable extends Component<OPProps> {
	componentDidMount(): void {
		this.configDataTable();
	}

	configDataTable = () => {
		const { type } = this.props;
		try {
			window.$( "#my-prop-table-" + type ).DataTable( {
                //language: LocaleUtil.Select(DataTableLang),
                language: { url: "https://cdn.datatables.net/plug-ins/1.10.20/i18n/" + (I8N.current == "ar" ? "Arabic.json" : "English.json"), lengthMenu: '_MENU_' },
                dom: "<'table-responsive'rt>" + "<'dt-cfooter'i<'dt-fpl'pl>>",
                pagingType: "simple_numbers",
				responsive: false,
				lengthChange: false,
				//scrollX: true
			} );
			const openDetails = this.openDetails;
			window.$( "#my-prop-table-" + type ).on( "click", "a", function () {
				// @ts-ignore
				let item = JSON.parse( this.getAttribute( "data-item" ) );
				// @ts-ignore
				let id = this.getAttribute( "id" );
				if ( item ) {
					if ( id === "download" ) {
						downloadCertificate( item );
					} else if ( id === "details" ) {
						openDetails( item );
					}
				}

				return false;
			} );
		} catch ( e ) {
			console.warn( "Data table unavailable", e );
		}
	};

	openDetails = ( property: AssetCard ) => {
		openDetails( property, this.props.isSelectable );
	};

	render() {
		const { properties, type, unit, isSelectable, masterProperty, sProperties, onSelect } = this.props;
		if ( properties == null || properties.length < 1 ) {
			return null;
		}
		let Header = LandHeader;
		let Row = LandRow;
		switch ( type ) {
			case TabuPropertyType.VILLA:
			case TabuPropertyType.BUILDING:
				Header = VillaHeader;
				Row = VillaRow;
				break;
			case TabuPropertyType.UNIT:
				Header = UnitHeader;
				Row = UnitRow;
				break;
		}
		return <ListDataView
			id={ "my-prop-table-" + type }
			title={ `${ getOPLabel( type ) } (${ properties!.length })` }
			items={ properties ? properties : [] }
			renderListHeader={ () => <Header isSelectable={ isSelectable }/> }
			renderListItem={ ( value: AssetCard ) => {
				return <Row
					key={ value.propertyId }
					isSqFt={ unit.Id === ImperialSystem.Id }
					property={ value }
					onDetails={ this.openDetails }
					onDownload={ downloadCertificate }
					isSelectable={ isSelectable }
					masterProperty={ masterProperty }
					sProperties={ sProperties }
					onSelect={ onSelect }/>;
			} }/>;
	}
}

export function getOPLabel( t: TabuPropertyType ) {
	switch ( t ) {
		case TabuPropertyType.LAND:
			return Strings.land_label;
		case TabuPropertyType.VILLA:
			return Strings.villa;
		case TabuPropertyType.UNIT:
			return Strings.unit;
		case TabuPropertyType.BUILDING:
			return Strings.villa;
	}
}

interface HeaderProps {
	isSelectable?: boolean;
}

interface RowProps {
	property: AssetCard;
	onDetails: ( p: AssetCard ) => void;
	onDownload: ( p: AssetCard ) => void;
	isSqFt: boolean;
	isSelectable?: boolean;
	masterProperty?: AssetCard;
	sProperties?: AssetCard[];
	onSelect?: ( p: AssetCard, checked: boolean ) => void;
}

function TD( props: { value?: string, className?: string, onClick?: () => void; label?: string } ) {
	let { value, className, label } = props;
	if ( value == null || StringUtil.isEmptyStringOrNull( value ) )
		value = "-";
	return <td
		data-label={ label } className={ className } onClick={ e => {
		e.preventDefault();
		if ( props.onClick ) props.onClick();
	} }>{ value }</td>;
}

function LH( props: { hideStatus?: boolean, hideOwnership?: boolean } ) {
	const { hideStatus, hideOwnership } = props;
	return <React.Fragment>
		<th>{ Strings.land_num_label }</th>
		<th>{ Strings.area_label }</th>
		<th>{ Strings.size }</th>
		{ !hideStatus &&
			<th>{ Strings.property_status.replace( "<br/>", "" ) }</th>
		}
		{ !hideOwnership &&
			<th>{ Strings.ownership } %</th>
		}
		<th>{ `${ Strings.purchase_price } (${ Strings.aed })` }</th>
		<th>{ `${ Strings.estimated_price } (${ Strings.aed })` }</th>
		<th>{ Strings.certificate }</th>
		<th>{ "" }</th>
	</React.Fragment>;
}

function LandHeader( props: HeaderProps ) {
	return <tr>
		{ props.isSelectable && <th/> }
		<LH/>
	</tr>;
}

function LR( props: RowProps & { xClass?: string, hideStatus?: boolean, hideOwnership?: boolean } ) {
	const { property, hideStatus, hideOwnership, isSqFt } = props;
	let { xClass } = props;

	let onClick = undefined;
	if ( xClass === "underline" ) {
		onClick = () => {
			props.onDetails( props.property );
		};
		xClass = xClass + " cur-hand";
	}
	const canDownload = !property.blockTransaction;
	return <React.Fragment>
		<TD
			label={ Strings.land_num_label } className={ "prop-mun-no " + ( xClass ? xClass : "" ) }
			value={ getOPMunNo( property ) } onClick={ onClick }/>
		{/*<TD className="prop-land-no" value={ property.landNo }/>*/ }
		<TD label={ Strings.area_label } className="prop-area" value={ LocaleUtil.getLocalValue( property.area ) }/>
		<TD label={ Strings.size } className="size" value={ getOPSize( property, isSqFt ) }/>
		{ !hideStatus &&
			<TD
				label={ Strings.property_status.replace( "<br/>", "" ) } className="prop-status"
				value={ LocaleUtil.getLocalValue( property.propertyStatus ) }/>
		}
		{ !hideOwnership &&
			<TD label={ Strings.ownership } className="prop-share" value={ getOPShare( property ) }/>
		}
		<TD
			label={ `${ Strings.purchase_price } (${ Strings.aed })` } className="currency"
			value={ getOPPurchase( property ) }/>
		<TD
			label={ `${ Strings.estimated_price } (${ Strings.aed })` } className="currency"
			value={ getOPEstimate( property ) }/>
		{ canDownload && <td className="props-actions align-self-center">
			<a
				className={ "cur-hand underline" }
				id={ "download" }
				data-item={ JSON.stringify( property ) }>
				{Strings.download}
			</a>
		</td>
		}
		{ !canDownload && <td className="props-actions align-self-center">

		</td>
		}
		<td>
			<a
				className={ "cur-hand underline" }
				id={ "details" }
				data-item={ JSON.stringify( property ) }>
				{Strings.view_details}
			</a>
		</td>
	</React.Fragment>;
}

function LandRow( props: RowProps ) {
	const { property, sProperties } = props;
	const isSelected = isPropertySelected( property, sProperties );
	return <tr className={ isSelected ? "active" : "" }>
		<PropertyCheckBox { ...props }/>
		<LR { ...props } xClass={ "underline" }/>
	</tr>;
}

function VillaHeader( props: HeaderProps ) {
	return <tr>
		{ props.isSelectable && <th/> }
		<th>{ Strings.name }</th>
		<LH/>
	</tr>;
}

function VillaRow( props: RowProps ) {
	const { property, sProperties } = props;
	const val = getVillaName( property );
	const isSelected = isPropertySelected( property, sProperties );
	return <tr className={ isSelected ? "active" : "" }>
		<PropertyCheckBox { ...props }/>
		<TD
			label={ Strings.name } className="prop-vil-no underline cur-hand" value={ val }
			onClick={ () => {
				props.onDetails( props.property );
			} }/>
		<LR { ...props }/>
	</tr>;
}

function UnitHeader( props: HeaderProps ) {
	return <tr>
		{ props.isSelectable && <th/> }
		<th>{ Strings.Unit_Number_Label }</th>
		<th>{ Strings.building_name }</th>
		<LH hideStatus={ true } hideOwnership={ true }/>
	</tr>;
}

function UnitRow( props: RowProps ) {
	const { property, sProperties } = props;
	const val = getUnitNumber( property );
	const isSelected = isPropertySelected( property, sProperties );
	return <tr className={ isSelected ? "active" : "" }>
		<PropertyCheckBox { ...props }/>
		<TD
			label={ Strings.Unit_Number_Label } className="prop-unit-no underline  cur-hand" value={ val }
			onClick={ () => {
				props.onDetails( props.property );
			} }/>
		<TD
			label={ Strings.building_name } className={ "prop-b-name" }
			value={ LocaleUtil.getLocalValue( ( property as any ).buildingName ) }/>
		<LR { ...props } hideStatus={ true } hideOwnership={ true }/>
	</tr>;
}

function PropertyCheckBox( props: RowProps ) {
	const { property, isSelectable, masterProperty, sProperties, onSelect } = props;
	if ( isSelectable ) {
		const canChange = property.propertyId !== masterProperty?.propertyId;
		const isSelected = isPropertySelected( property, sProperties );
		const onChange = ( e: ChangeEvent<HTMLInputElement> ) => {
			if ( onSelect ) {
				onSelect( property, e.target.checked );
			}
		};
		return <td>
            <div style={{ pointerEvents: canChange ? "auto" : "none" }} className="form-check">
                <input className="form-check-input" id={`${property.propertyId}`} type="checkbox" checked={isSelected} onChange={onChange} />
                <label className="form-check-label" htmlFor={`${property.propertyId}`}>
                    <span className="sr-only" />
                </label>
            </div>
		</td>;
	}
	return null;
}

export function getOPMunNo( property: AssetCard ) {
	let munNo = property.municipalityNo;
	if ( munNo.startsWith( "-" ) )
		munNo = munNo.slice( 1 );
	else if ( munNo.endsWith( "-" ) )
		munNo = munNo.slice( 0, -1 );
	return munNo;
}

export function getOPSize( property: AssetCard, isSqFt: boolean ) {
	return ( isSqFt ? property.size.squareFeet : property.size.squareMeter ) + "";
}

export function getOPShare( property: AssetCard ) {
	let share: string | number = property.shareValue;
	if ( share > 100 ) share = 100;
	return share.toFixed( 2 ) + "%";
}

export function getOPPurchase( property: AssetCard ) {
	let inValue: string | number | null = property.investmentValue;
	if ( inValue == null || inValue <= 0 )
		inValue = "";
	else
		inValue = CurrencyUtil.toFormattedCurrency( inValue );
	return !isEmptyStringOrNull( inValue ) ? inValue.substr( 0, inValue.lastIndexOf( "." ) ) : "-";
}

export function getOPEstimate( property: AssetCard ) {
	let estValue: string | number | null = property.estimatedValue;
	if ( estValue == null || estValue <= 0 )
		estValue = "";
	else
		estValue = CurrencyUtil.toFormattedCurrency( estValue );
	return !isEmptyStringOrNull( estValue ) ? estValue.substr( 0, estValue.lastIndexOf( "." ) ) : "-";
}

export function isPropertySelected( property: AssetCard, properties?: AssetCard[] ) {
	if ( property && properties ) {
		return properties.indexOf( property ) !== -1;
	}
	return false;
}

export function openDetails( property: AssetCard, isSelectable?: boolean ) {
	let path = `/mydld/property/${ property.propertyTypeId }/${ property.propertyId }`;
	if ( isSelectable ) {
		path = `${ path }/${ true }`;
	}
	navigate( path, undefined, { property: property } );
}

export default PropertyTable;
